"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
const Types = {
    FalconLookupService: Symbol.for("FalconLookupService"),
    BaseRequestService: Symbol.for("BaseRequestService"),
    NotificationService: Symbol.for("NotificationService"),
    FalconConvenienceApiServiceConfig: Symbol.for("FalconConvenienceApiServiceConfig"),
    FalconConvenienceApiService: Symbol.for("FalconConvenienceApiService"),
    CacheManager: Symbol.for("CacheManager"),
    LoggerService: Symbol.for("LoggerService"),
    MonitoringToolService: Symbol.for("MonitoringToolService"),
    RuntimeServiceConfig: Symbol.for("RuntimeServiceConfig"),
    FalconPropositionEngine: Symbol.for("FalconPropositionEngine")
};
exports.Types = Types;
//# sourceMappingURL=Types.js.map